module.exports = __webpack_public_path__ + "img/模.6511bf4a.png";